module.exports = __webpack_public_path__ + "static/media/18.2846f724.mp3";